export const revealDocuments = (data: any) => [
  ...data?.map(({ id, title, ...otherProps }: any) => ({ info: { id, title }, ...otherProps })),
];
